










import { Component, Vue } from 'vue-property-decorator';
import { Task } from './components/Task.vue';
import DayOverview from './components/DayOverview.vue';

export const LS_TASKS = 'tasks';
export const LS_BACKLOG = 'backlog';

@Component({
  components: {
    'day-overview': DayOverview,
  },
})
export default class App extends Vue {

  tasks: Task[] = [];
  backlog: Task[] = [];

  get filteredTasks() {
    const start = new Date();
    start.setHours(0,0,0,0);
    return this.tasks.filter(t => !t.done || (t.fulfilled && t.fulfilled > start));
  }

  created() {
    this.restore();

    this.$root.$data.bus.$on('save', () => this.save());
    this.$root.$data.bus.$on('remove', (id: number, a: boolean) => this.remove(id, a));
    this.$root.$data.bus.$on('setActive', (id: number) => this.setActive(id));
    this.$root.$data.bus.$on('setInactive', (id: number) => this.setInactive(id));
  }

  add(scope: 'today' | 'backlog') {
    let task: Task = {
      id: this.uuid(),
      title: '',
      done: false,
      created: new Date()
    }
    if (scope === 'today') {
      task.activated = task.created;
      this.tasks.push(task);
    } else {
      this.backlog.push(task);
    }

    this.save();
  }

  remove(id: number, active: boolean) {
    let target = active ? this.tasks : this.backlog;
    const idx = target.findIndex(t => t.id === id);
    if (idx >= 0) target.splice(idx, 1);

    this.save();
  }

  setActive(id: number) {
    const idx = this.backlog.findIndex(t => t.id === id);
    const task = this.backlog.splice(idx, 1)[0];
    task.activated = new Date();
    this.tasks.push(task);

    this.save();
  }

  setInactive(id: number) {
    const idx = this.tasks.findIndex(t => t.id === id);
    this.backlog.splice(0, 0, this.tasks.splice(idx, 1)[0]);

    this.save();
  }

  /* Storage */

  private restore() {
    let tasks = localStorage.getItem(LS_TASKS);
    let backlog = localStorage.getItem(LS_BACKLOG);
    if (tasks)  {
      this.tasks = this.parseDates(JSON.parse(tasks));
    }
    if (backlog)  {
      this.backlog = this.parseDates(JSON.parse(backlog));
    }
  }

  private save() {
    localStorage.setItem(LS_TASKS, JSON.stringify(this.tasks));
    localStorage.setItem(LS_BACKLOG, JSON.stringify(this.backlog));
  }


  /* Helper functions */

  private uuid() {
    return Math.floor(Date.now() * Math.random());
  }

  private parseDates(tasks: Task[]) {
    tasks.forEach(t => {
      t.created = t.created && new Date(t.created);
      t.activated = t.activated && new Date(t.activated);
      t.fulfilled = t.fulfilled && new Date(t.fulfilled);
    });
    return tasks;
  }
  
}
